// Mock data for AGIPLUS CI website

export const contactSubmissions = [];

export const submitContactForm = (formData) => {
  const submission = {
    id: Date.now().toString(),
    ...formData,
    timestamp: new Date().toISOString()
  };
  contactSubmissions.push(submission);
  return submission;
};

export const products = [
  {
    id: 1,
    name: "Flexibles hydrauliques haute pression",
    category: "Hydraulique",
    description: "Flexibles sur mesure pour applications industrielles"
  },
  {
    id: 2,
    name: "Vérins hydrauliques",
    category: "Hydraulique",
    description: "Réfection et maintenance de vérins"
  },
  {
    id: 3,
    name: "Raccords et embouts",
    category: "Mécanique",
    description: "Large gamme de raccords hydrauliques"
  },
  {
    id: 4,
    name: "Extracteurs industriels",
    category: "Ventilation",
    description: "Systèmes d'extraction pour ventilation"
  },
  {
    id: 5,
    name: "Conduits PVC",
    category: "Ventilation",
    description: "Réseaux d'aération et conduits"
  },
  {
    id: 6,
    name: "Conteneurs aménagés",
    category: "Aménagement",
    description: "Ateliers mobiles et stockage"
  }
];

export const clients = [
  { id: 1, name: "Eiffage" },
  { id: 2, name: "Sogea-Satom" },
  { id: 3, name: "Bouygues Construction" },
  { id: 4, name: "Colas" },
  { id: 5, name: "Vinci Construction" },
  { id: 6, name: "Razel-Bec" }
];

export const services = [
  {
    id: 1,
    title: "Hydraulique",
    description: "Réfection et maintenance de vérins hydrauliques, confection sur mesure de flexibles haute pression",
    icon: "wrench"
  },
  {
    id: 2,
    title: "Mécanique Industrielle",
    description: "Fourniture de pièces mécaniques et hydrauliques : coupleurs, embouts, raccords",
    icon: "cog"
  },
  {
    id: 3,
    title: "Aménagement Technique",
    description: "Aménagement de conteneurs en ateliers mobiles et espaces de stockage",
    icon: "container"
  },
  {
    id: 4,
    title: "Ventilation Industrielle",
    description: "Installation de systèmes de ventilation : réseaux, extracteurs, boîtiers",
    icon: "wind"
  }
];